import { Spin } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import SpinnerComponent from "../../../components/SpinnerComponent/SpinnerComponent";
import { setRTMPStream } from "../../../redux/lives/livesSlice";
import { AppDispatch } from "../../../redux/store";
import { liveService, messageService } from "../../../services";
import { DEFAULT_FAN_HOME_REDIRECT_URL } from "../../../utls/constants";

function FanHomeMessagerieWrapper() {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [totalNotReadMessages, setTotalNotReadMessages] = useState<number | null>(null);
  const [rtmpNavgation, setRtmpNavigation] = useState<string>("");
  const redirectUrl = localStorage.getItem("redirectToEvent");
  const searchParams = new URLSearchParams(location.search);
  const isRtmpLive = localStorage.getItem("redirectToEvent") !== null;
  const [isRtmpLiveLoading, setIsRtmpLiveLoading] = useState<boolean>(!!redirectUrl);

  useEffect(() => {
    // TODO: enable this code for the upcoming event
    const creatorCode = searchParams.get("code");
    if (creatorCode && localStorage.getItem("creatorCode") !== creatorCode) {
      localStorage.setItem("creatorCode", creatorCode);
    }
    if (redirectUrl) {
      fetchRtmpLive(redirectUrl);
    } else {
      fetchUnreadMessages();
    }
  }, []);

  const fetchRtmpLive = async (redirectUrl: string) => {
    setIsRtmpLiveLoading(true);
    try {
      const live = await liveService.getRtmpLive();
      dispatch(setRTMPStream(live));
      if (live) {
        const redirectRtmpUrl = live.isPaymentVerified
          ? live.isStreaming
            ? `/fan/live/${live._id}`
            : "/fan/sebyvsstrongui"
          : "/".concat(redirectUrl);
        setTotalNotReadMessages(0);
        setRtmpNavigation(redirectRtmpUrl);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsRtmpLiveLoading(false);
    }
  };

  const fetchUnreadMessages = async () => {
    try {
      const total = await messageService.getTotalNotReadMessages();
      if (total && total !== "") {
        setTotalNotReadMessages(parseInt(total, 10));
      } else {
        setTotalNotReadMessages(0);
      }
    } catch (error) {
      console.error(error);
      setTotalNotReadMessages(0);
    }
  };

  if (isRtmpLiveLoading) {
    return <Spin spinning={isRtmpLiveLoading} style={{ height: "100%", width: "100%" }} indicator={<SpinnerComponent />} />;
  }

  if (rtmpNavgation) {
    localStorage.removeItem("redirectToEvent");
    return <Navigate to={rtmpNavgation} replace />;
  } else if (location.pathname === "/sebyvsstrongui" && !redirectUrl) {
    fetchRtmpLive("fan/sebyvsstrongui");
    return <Navigate to={"/fan/sebyvsstrongui"} replace />;
  }

  if (!isRtmpLive && location.pathname !== "/sebyvsstrongui") {
    return <Navigate to={DEFAULT_FAN_HOME_REDIRECT_URL} replace />;
  }

  // if (totalNotReadMessages === null) {
  //   return null;
  // }

  if (totalNotReadMessages && totalNotReadMessages > 0) {
    return <Navigate to="/fan/message" replace />;
  } else {
    return <Navigate to={DEFAULT_FAN_HOME_REDIRECT_URL} replace />;
  }
}

export default FanHomeMessagerieWrapper;
